import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getStyleGuide } from "../services/styleGuideService";

export const fetchstyleGuideThunk = createAsyncThunk(
    "styleGuide/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const res = await getStyleGuide();
            return res?.data ?? res;
        } catch (err) {
            return rejectWithValue(
                err?.message || "Failed to fetch style guide"
            );
        }
    }
);

const initialState = {
    data: null,
    status: "idle", // idle | loading | succeeded | failed
    error: null,
};

const styleGuideSlice = createSlice({
    name: "styleGuide",
    initialState,
    reducers: {
        resetstyleGuide: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchstyleGuideThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchstyleGuideThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data = action.payload;
            })
            .addCase(fetchstyleGuideThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            });
    },
});

export const { resetstyleGuide } = styleGuideSlice.actions;
export default styleGuideSlice.reducer;
